<div
  class="fk-toast fk-p4"
  [class]="getToastCls()"
  (click)="onClose()"
>
  <fk-icon
    class="fk-toast__icon"
    [class]="getIconCls()"
    [name]="getIconName()"
    [size]="22"
  ></fk-icon>

  <div class="fk-toast__content">
    <span class="fk-toast__title">{{ title }}</span>

    @if (text) {
      <span class="fk-toast__content-text">{{ text }}</span>
    } @else if (textTpl) {
      <ng-container *ngTemplateOutlet="textTpl"></ng-container>
    }
  </div>

  @if (closeable) {
    <button
      class="fk-btn fk-btn-small fk-btn-ghost fk-toast__close-btn"
      (click)="onClose()">
      <fk-icon
        class="fk-toast__close-icon"
        name="close"
        [size]="20"
      ></fk-icon>
    </button>
  }
</div>
